import styled from 'styled-components';
import Inner from '../components/Inner';
import PageTitle from '../components/PageTitle';
import ArtistCard from '../components/ArtistCard';
import artists from '../mock/artists.json';

const CardContainer = styled.div`
	width: 100%;
	margin: 0 auto 10rem;
	display: flex;
	align-items: center;
	justify-content: start;
	flex-wrap: wrap;

	@media (max-width: 767px) {
		margin: 0 auto 6rem;
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		margin: 0 auto 8rem;
	}
`;

function Artists() {
	return (
		<Inner>
			<PageTitle>Artists</PageTitle>
			<CardContainer>
				{artists.map((artist, idx) => {
					return (
						<ArtistCard
							key={idx}
							img={artist.img}
							name={artist.name}
							part={artist.part}
						/>
					);
				})}
			</CardContainer>
		</Inner>
	);
}

export default Artists;
